import React from "react";
import { TIMELINE_HEADER_HEIGHT } from "./timelineConstants";

interface ResourceHeaderProps {
  resourceHeaderContent?: React.ReactNode;
}

const ResourceHeader: React.FC<ResourceHeaderProps> = ({
  resourceHeaderContent,
}) => {
  return (
    <div
      className="resource-header"
      style={{ height: `${TIMELINE_HEADER_HEIGHT}px` }}
    >
      {resourceHeaderContent || "Resources"}
    </div>
  );
};

export default ResourceHeader;
